import moment from 'moment-timezone';

import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('topicAnalytic');
const GET_TOPIC_LIST = define('GET_TOPIC_LIST', true);
const GET_TOPIC_ANALYTIC_ITEM = define('GET_TOPIC_ANALYTIC_ITEM', true);

const initialState = {
  firstLoad: true,
  loading: true,
  data: {},
  isLoadingList: true,
  isShowAll: false,
  topics: [],
  // isLoadingMore: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOPIC_LIST.PENDING:
      return {
        ...state,
        isLoadingList: true
        // isLoadingMore: action.showAll
        // isLoadingList: true,
        // topics: []
      };
    case GET_TOPIC_LIST.RESOLVED:
      return {
        ...state,
        isLoadingList: false,
        topics: action.data,
        isShowAll: action.showAll,
        // isLoadingMore: false
      };
    case GET_TOPIC_ANALYTIC_ITEM.PENDING:
      return {
        ...state,
        loading: true
      };
    case GET_TOPIC_ANALYTIC_ITEM.RESOLVED:
      return {
        ...state,
        loading: false,
        data: action.data,
        firstLoad: false
      };
    default: return state;
  }
};

export const actions = {
  getTopicList: (query = 'tags=all') => ({
    type: GET_TOPIC_LIST,
    promise: api.get(`/warehouses/topic?${query}`),
    error: 'Unable to get topic list',
  }),
  getTopicAnalyticItem: (topicId, from = moment().subtract(1, 'months').startOf('days').format('YYYY-MM-DD'), to = moment().endOf('days').format('YYYY-MM-DD'), userType = 'unknown') => ({
    type: GET_TOPIC_ANALYTIC_ITEM,
    promise: api.get(`/warehouses/topic/${topicId}?from=${from}&to=${to}&userType=${userType}`),
    error: 'Unable to get topic analytic data'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/topic-analytic.js